import { Button } from '../../cdl/Button/Button';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

import { SsoBanner } from './SsoBanner';

interface SsoAdvertisementBannerProps {
    onContactSupport: () => void;
}

export const SsoAdvertisementBanner = ({ onContactSupport }: SsoAdvertisementBannerProps) => {
    return (
        <SsoBanner display="flex" flexDirection="column" gap={16}>
            <Text variant="subtitle1" as="h2">
                {translate('sso.advertisement.headline')}
            </Text>
            <Text variant="body" color="foreground.subtle">
                {translate('sso.advertisement.description')}
            </Text>
            <Box>
                <Button emphasis="high" onClick={onContactSupport}>
                    {translate('sso.contactSupport')}
                </Button>
            </Box>
        </SsoBanner>
    );
};
